import Swiper from "../../node_modules/swiper";
import { Autoplay, Navigation } from '../../node_modules/swiper/modules/';

// Note I've not included Navigation intentionally

function runSwiperFeature() {
  if ($(".js-swiper-feature").length > 0) {
    $(".js-swiper-feature-container").each(function (i) {

      new Swiper($(this)[0], {
        modules: [Autoplay, Navigation],
        // Disable preloading of all images
        preloadImages: false,
        // Enable lazy loading
        lazy: true,
        // watchOverflow: true,
        grabCursor: true,
        autoplay: {
          delay: 100000
        },
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // effect: 'fade',
        // fadeEffect: {
        //   crossFade: true
        // },
        // lazy: {
        //   loadPrevNext: true
        // },

      });
    });
  }
}

export { runSwiperFeature };
